/**
 * Shared mobile validation + OTP helpers for landing page forms.
 */

export function validateLandingMobile(mobile) {
  const value = String(mobile ?? '').trim();
  if (!value) {
    return 'Please enter your mobile number.';
  }
  if (!/^\d+$/.test(value)) {
    return 'Mobile number must contain only digits.';
  }
  if (value.length !== 10) {
    return 'Mobile number must be 10 digits.';
  }
  if (!/^[6-9]\d{9}$/.test(value)) {
    return 'Mobile number should start with 6 to 9.';
  }
  return null;
}

export function getApiErrorMessage(responseOrError, fallback = 'Something went wrong. Please try again.') {
  if (!responseOrError) return fallback;
  if (typeof responseOrError === 'string') return responseOrError;
  return (
    responseOrError?.data?.msg ||
    responseOrError?.response?.data?.msg ||
    responseOrError?.message ||
    fallback
  );
}
